<!-- <div class="circle" style="height: {{circleSize}}; width: {{circleSize}}">
    <span class="initials" style="font-size:{{fontSize}};  top: {{topSize}}">{{initials}}</span>
</div> -->

<div
  class="circle"
  [ngClass]="{ small: small, large: large }"
  [ngStyle]="{ 'background-color': circleColor }">
  <img *ngIf="!showInitials" src="{{ photoUrl }}" />

  <div
    class="initials"
    *ngIf="showInitials"
    [ngClass]="!initialsColor && 'initials-default-color'"
    [ngStyle]="initialsColor && { color: initialsColor }">
    {{ initials }}
  </div>
</div>
